import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMenuPositions } from '../hooks/useMenuPositions';
import { formFileUrlFromDbFile } from '../../../utils/fileHelper';
import MenuBar from './menuBar';
import { getSelectedCategory } from '../services/categories';
import TopBar from '../../../layouts/place/topBar';
import { getTranslatedData } from '../../../localization';

const Menu = ({ menu }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const {
    windowHeight,
    scrollPosition,
    categoriesY,
    categoriesRef,
    onImagePositionChange,
    canShowMenu,
  } = useMenuPositions(menu);

  if (menu.type === 'Link') {
    if (!menu.externalLink) {
      return (
        <div className="sticky top-0 bg-white z-10">
          <TopBar title={t('header.menu')} onBack={() => navigate('/')} />
        </div>
      );
    }

    return (
      <div>
        <div className="sticky top-0 bg-white z-10">
          <TopBar title={t('header.menu')} onBack={() => navigate('/')} />
        </div>
        <div className="flex flex-col justify-center items-center mt-10">
          <a
            href={menu.externalLink}
            target="_blank"
            rel="noreferrer"
            className="font-primaryMedium text-2xl text-primary"
          >
            {t('menu.openMenuLink')}
          </a>
        </div>
      </div>
    );
  }

  if (!menu.categories || menu.categories.length === 0) {
    return (
      <div className="sticky top-0 bg-white z-10">
        <TopBar title={t('header.menu')} onBack={() => navigate('/')} />
      </div>
    );
  }

  const onManualSelect = (categoryId, scrollerHeight) => {
    const categoryPosition = categoriesY[categoryId || ''];

    // eslint-disable-next-line no-undef
    window.scrollTo({
      top: scrollerHeight ? categoryPosition - 110 - scrollerHeight + 54 : categoryPosition - 110,
      behavior: 'smooth',
    });
  };

  const renderMenuImage = (category, imageUrl, ind) => {
    return <img key={`${ind}`} className="h-auto" src={imageUrl} alt="category" />;
  };

  const renderCategoryMenu = (category, ind) => {
    return (
      <div
        key={`${ind}`}
        ref={(el) => {
          if (!el) {
            return;
          }

          const oldPos = categoriesRef.current[category.id];
          categoriesRef.current[category.id] = { offsetTop: el ? el.offsetTop : 0 };

          // Position change on initial load
          if (oldPos && oldPos.offsetTop !== el.offsetTop && ind === menu.categories.length - 1) {
            onImagePositionChange();
          }
        }}
      >
        {(getTranslatedData(category.images) || []).map((dbImage, imageInd) => {
          const imageUrl = formFileUrlFromDbFile(dbImage);

          return renderMenuImage(category, imageUrl, imageInd);
        })}
      </div>
    );
  };

  const selected = getSelectedCategory({ windowHeight, scrollPosition, categoriesY });

  return (
    <div style={{ visibility: canShowMenu ? 'visible' : 'hidden' }}>
      <div className="sticky top-0 bg-white z-10 -mx-5 px-5">
        <TopBar title={t('header.menu')} onBack={() => navigate('/')} />
        <MenuBar menu={menu} selected={selected} onSelect={onManualSelect} />
      </div>
      <div className="flex flex-col justify-center items-center">
        {menu.categories.map((category, ind) => {
          return renderCategoryMenu(category, ind);
        })}
      </div>
    </div>
  );
};

export default Menu;
